import { render } from "./HomePageLinks.vue?vue&type=template&id=4ed60b3e&ts=true"
import script from "./HomePageLinks.vue?vue&type=script&lang=ts"
export * from "./HomePageLinks.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__